import type { ValueOf } from 'type-fest';

export const TENANT_TYPE = {
  PRIVATE: 'private',
  COMPANY: 'company',
} as const;

export type TenantTypes = ValueOf<typeof TENANT_TYPE>;

export const TENANT_STATUS = {
  ACTIVE: 0,
  ACTIVE_FURTHER: 1,
  ACTIVE_DEFINITE_END: 2,
  CANCELLED_PENDING_NEGOTIATION: 3,
  CANCELLED_PENDING: 4,
  CANCELLED_NEGOTIATION: 5,
  CANCELLED: 6,
  OWNER_WARNING: 7,
  COUNTERPART_WARNING: 8,
  UPCOMING: 9,
  NOT_SIGNED: 10,
  INACTIVE_CANCELLATION_NOT_SIGNED: 11,
  INACTIVE: 12,
};

export const TENANT_ACTIVE_STATUSES = [
  TENANT_STATUS.ACTIVE,
  TENANT_STATUS.ACTIVE_FURTHER,
  TENANT_STATUS.ACTIVE_DEFINITE_END,
  TENANT_STATUS.CANCELLED_PENDING_NEGOTIATION,
  TENANT_STATUS.CANCELLED_PENDING,
  TENANT_STATUS.CANCELLED_NEGOTIATION,
  TENANT_STATUS.CANCELLED,
  TENANT_STATUS.OWNER_WARNING,
  TENANT_STATUS.COUNTERPART_WARNING,
];
